var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 4.875C10.125 4.46079 10.4608 4.125 10.875 4.125H12C12.4142 4.125 12.75 4.46079 12.75 4.875C12.75 5.28921 12.4142 5.625 12 5.625H10.875C10.4608 5.625 10.125 5.28921 10.125 4.875Z",
    fill: "#40A0C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.125C9.33579 7.125 9 7.46079 9 7.875C9 8.28921 9.33579 8.625 9.75 8.625H12C12.4142 8.625 12.75 8.28921 12.75 7.875C12.75 7.46079 12.4142 7.125 12 7.125H9.75Z",
    fill: "#40A0C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.875C9 10.4608 9.33579 10.125 9.75 10.125H12C12.4142 10.125 12.75 10.4608 12.75 10.875C12.75 11.2892 12.4142 11.625 12 11.625H9.75C9.33579 11.625 9 11.2892 9 10.875Z",
    fill: "#40A0C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C2.17157 0 1.5 0.671573 1.5 1.5V4.125H0.75C0.335786 4.125 0 4.46079 0 4.875V11.625C0 12.0392 0.335786 12.375 0.75 12.375H1.5V15C1.5 15.8284 2.17158 16.5 3 16.5H13.5C14.3284 16.5 15 15.8284 15 15V1.5C15 0.67158 14.3284 0 13.5 0H3ZM7.5 12.375H3V15H13.5V1.5H3V4.125H7.5C7.91421 4.125 8.25 4.46079 8.25 4.875V11.625C8.25 12.0392 7.91421 12.375 7.5 12.375ZM2.46967 7.65533C2.17678 7.36244 2.17678 6.88756 2.46967 6.59467C2.76256 6.30178 3.23744 6.30178 3.53033 6.59467L4.125 7.18934L4.71967 6.59467C5.01256 6.30178 5.48744 6.30178 5.78033 6.59467C6.07322 6.88756 6.07322 7.36244 5.78033 7.65533L5.18566 8.25L5.78033 8.84467C6.07322 9.13756 6.07322 9.61244 5.78033 9.90533C5.48744 10.1982 5.01256 10.1982 4.71967 9.90533L4.125 9.31066L3.53033 9.90533C3.23744 10.1982 2.76256 10.1982 2.46967 9.90533C2.17678 9.61244 2.17678 9.13756 2.46967 8.84467L3.06434 8.25L2.46967 7.65533Z",
    fill: "#40A0C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.cf74089d732472b564b8d712dfd37c8e.svg";
export { ForwardRef as ReactComponent };